import { createAsyncThunk } from "@reduxjs/toolkit";
import { config, tld } from "services/globalvariables/globalvariables";
//
import axios from "axios";
//
import { allNewProducts } from "services/api/allApiHub";
import { createSlice } from "@reduxjs/toolkit";

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${tld}${allNewProducts}`, config);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
//
// Async thunk to fetch products by Category //
//
export const fetchProductsByCategory = createAsyncThunk(
  "products/fetchProductsByCategory",
  async (id) => {
    try {
      const response = await axios.get(
        `${tld}showroom/api/v1/product_list/?q=${id}&filter_by_category=machine_category_id`,
        config
      );
      return response.data.data;
    } catch (err) {
      console.log(err);
      return err.message;
    }
  }
);

// Async thunk to fetch products by subcategory
export const fetchProductsBySubCategory = createAsyncThunk(
  "products/fetchProductsBySubCategory",
  async (id) => {
    try {
      const response = await axios.get(
        `${tld}showroom/api/v1/product_search/?sub_category=${id}`,
        config
      );
      return response.data.data;
    } catch (err) {
      console.log(err);
      return err.message;
    }
  }
);
//
// Function to get all products filtered on type i.e new/used ........
//
//
export const fetchProductsByProductType = createAsyncThunk(
  "products/fetchProductsByProductType",
  async (type) => {
    try {
      const response = await axios.get(
        `${tld}/showroom/api/v1/product_search/?product_type=${type}`,
        config
      );
      return response.data.data;
    } catch (err) {
      console.log(err);
      return err.message;
    }
  }
);
//
//
//
// Define the new product slice filteration....
//
//
const productsSlice = createSlice({
  name: "products",
  initialState: {
    items: [],
    status: "idle",
    error: null,
  },
  reducers: {
    filterCurrentData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch products";
      });

    //
    builder
      .addCase(fetchProductsByCategory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchProductsByCategory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchProductsByCategory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch";
      });
    //
    //
    builder
      .addCase(fetchProductsBySubCategory.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchProductsBySubCategory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchProductsBySubCategory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch";
      });
    //
    //
    builder
      .addCase(fetchProductsByProductType.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchProductsByProductType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchProductsByProductType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch";
      });
  },
});

export default productsSlice.reducer;
